<!--
    A single flash message, should be rendered by flashStack.vue
-->
<template>
    <div class="flash-wrapper">
        <div class="flash"
            :class="computedClasses"
            v-show="this.visible"
            role="alert"
        >
            <button
                type="button"
                v-show="this.important"
                class="close"
                @click="hide"
                aria-label="Close"
            ><span aria-hidden="true">&times;</span>
            </button>

            <b v-show="this.title">
                {{ this.title }}:
            </b>
                {{ this.message }}
        </div>
    </div>
</template>

<script>
export default {
    props: ['object', 'numberInStack'],
    mounted() {
        if (!this.object.important) {
            this.hideWithDelay();
        }
    },

    data() {
        return {
            message: this.object.message,
            level: this.object.level,
            important: this.object.important,
            title: this.object.title,
            key: this.key,
            numberInStackData: this.numberInStack,
            visible: true
        };
    },

    methods: {
        hideWithDelay() {
            setTimeout(() => {
                this.hide();
            }, 4000);
        },
        hide() {
            this.$emit('hide', this.numberInStack);
        }
    },

    computed: {
        computedClasses() {
            const computedClasses = [];

            computedClasses.push(
                this.level ? `flash--alert-${this.level}` : 'flash--alert-success'
            );

            if (this.object.important) {
                computedClasses.push('flash--alert-dismissable');
            }

            return computedClasses.join(' ');
        }
    }
};
</script>
